<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Задачи
    v-col(cols="12" id="listTasks")
      .d-flex.align-center.mb-4
          v-tabs(v-model="tab" background-color="transparent"  show-arrows)
            v-tab Мои задачи
            v-tab Поставленные задачи
          v-menu(
            transition="slide-y-transition"
            open-on-hover
            offset-y
          )
            template(v-slot:activator="{on}")
              v-btn(v-on="on" color="accent").mr-2
                | {{ typeOfListValue }}
                v-icon(right) mdi-chevron-down
            v-list
              v-list-item(
                v-for="(item, index) in typeOfList"
                :key="index"
                :disabled="item === typeOfListValue ? true : false"
                @click="typeOfListValue = item"
              ) {{ item }}
          v-menu(
            transition="slide-y-transition"
            :close-on-content-click="false"
            offset-y
          )
            template(v-slot:activator="{ on }")
              v-btn(v-on="on")
                | Фильтр
                v-icon(right) mdi-filter
            v-card.pa-4(outlined)
              v-select(
                label="Статус"
                v-model="taskStatus"
                item-value="value"
                item-text="name"
                :items="Object.values(TASK_STATUS)"
                filled
                hide-details
              ).mr-4
              v-text-field.mr-4.mt-6( filled @click="dialogDoneDate=true" label="Дата сдачи"
              :value=" filters.startDoneDate && filters.endDoneDate ? String(filters.startDoneDate + '---' + filters.endDoneDate) : '' ")
              select-my-user.mr-4(filled label="Исполнитель" v-model="filters.workerIds")
              v-btn.mr-4( width="100%" @click="sortButton ? sortButton = false : sortButton = true")
                span Сортировать  дате создания
                v-icon {{ sortButton ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
              v-btn.mt-5(width="100%" @click="filters={}") сбросить
      v-card.pa-4.mb-5.task(
        v-if="typeOfListValue === 'Список'"
        outlined
        v-for="task in tasks"
        :key="task.id"
      )
        v-card-title {{task.name}}
        v-card-text
          v-col(cols="12")
            v-icon mdi-information-outline
            | Описание: {{task.description}}
          v-col(cols="12")
            v-icon mdi-calendar
            | {{task.notify_at | readableDateTime}}
          v-col(cols="12")
            v-icon mdi-file
            | Вложения: {{taskAttacments(task.id)}}
          v-col(cols="12" )
            v-icon mdi-account
            | {{seeAuthor(task)}}
        router-link.task-actions(:to="`/tasks/${task.id}`") Подробнее
      v-col(cols="12" v-if="loadingNewTasks" )
        v-sheet(v-for="i in 5" :key="i" :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`")
          v-skeleton-loader(type="card")
      router-link(to="/create-task")
        v-btn(color="success")
          v-icon(left) mdi-plus
          | Добавить задачу
  v-dialog(
    v-model="dialogDoneDate"
  )
    v-card(outline dark)
      v-tabs(v-model="doneTab")
        v-tab Выберите дату начала промежутка
        v-tab Выберите дату окончания промежутка
      v-date-picker(
        v-if="doneTab === 0"
        first-day-of-week="1"
        v-model="filters.startDoneDate"
        dark
        @click:date="doneTab += 1"
        no-title
        scrollable
        full-width
      )
      v-date-picker(
        v-if="doneTab === 1"
        first-day-of-week="1"
        v-model="filters.endDoneDate"
        dark
        @click:date="dialogDoneDate = false"
        no-title
        scrollable
        full-width
      )
  calendar-task(
    v-if="typeOfListValue === 'Календарь'"
    :tasks="tasks"
  )

</template>
<script>
import { CRUDFolders } from '@/services/API/folder';
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import { CACHE_KEYS } from '@/store/modules/cache';
import Element from '@/components/icons/Element.vue';
import { TASK_STATUS } from '../constants';
import  { CRUDTasks } from '@/services/API/task';
import { mapGetters, mapActions } from 'vuex';
import { getPagination } from '@/lib/pagination';
import mixinDateTime from '@/mixins/mixinDateTime';
import CalendarTask from '../components/CalendarTask/index.vue';

export default {
  components: {
    Element,
    SelectMyUser,
    CalendarTask,
  },
  mixins: [mixinDateTime],
  data() {
    return {
      dialogDoneDate: false,
      sortButton: false,
      tab: 0,
      doneTab: 0,
      typeOfList: ['Список', 'Календарь'],
      typeOfListValue: 'Список',
      folders: [],

      tasks: [],
      taskStatus: 1,
      createTaskStatus: false,

      pagination: {
        page: 1,
        pages: 1,
      },
      filters: {
        startCreateDate: null,
        endCreateDate: null,
        startDoneDate: null,
        endDoneDate: null,
        workerIds: null,
      },
      loadingNewTasks: false,

      TASK_STATUS,
    };
  },
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      cachedUser : 'cache/cachedUser',
    }),
  },
  watch: {
    tab: {
      handler() {
        if (this.tasks) this.tasks = [];
        this.pagination = { page: 1, pages:1 };
        this.fetchTasks();
      },
    },
    sortButton: {
      handler() {
        if (this.tasks) this.tasks = [];
        this.fetchTasks();
      },
    },
    filters: {
      deep: true,
      handler() {
        if (this.tasks) this.tasks = [];
        this.fetchTasks();
      },
    },
    taskStatus: {
      immediate: true,
      handler() {
        if (this.tasks) this.tasks = [];
        this.fetchTasks();
      },
    },
  },
  async created() {
    await this.fetchFolders();
  },
  mounted() {
    // const documentElement = document.querySelector('#listTasks');
    window.onscroll = () => {
      const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.pagination.page += 1;
        this.fetchTasks();
      }
    };
  },
  methods: {
    ...mapActions({
      'loadToCache': 'cache/loadToCache',
    }),
    async fetchFolders() {
      const params = {
        'search[target_id]': this.taskId,
        'expand': 'images,documents',
      };
      const response = await CRUDFolders.getAll(params);
      this.folders = response.data.data;
    },
    taskAttacments(taskID) {
      const taskFolders = this.folders.filter(({ target_id }) => target_id === taskID);
      const folders = taskFolders.length;
      let result = 0;
      taskFolders.forEach(({ images, documents }) => {
        result += [...images, ...documents].length;
      });
      if (!result && !folders) return 'Нет вложений';
      return `${folders} групп файлов и ${result} вложений`;
    },
    seeAuthor(task) {
      if (task.owner_id === this.user.id) {
        return `${task.users[0]?.profile_name || task.users[0]?.username} ${task.users.length - 1 ? String('+', task.users.length - 1, 'участников') : ''}`;
      }
      return this.cachedUser(task.owner_id).username;
    },
    async fetchTasks() {
      if (this.pagination.pages < this.pagination.page) return;
      this.loadingNewTasks = true;
      try {
        const params = {
          'search[period_notify_at][from_at]': null,
          'search[period_notify_at][to_at]': null,
          'search[user_id]': null,
          'search[status]': this.taskStatus,
          'search[owner_id]': this.user.id,
          'expand': 'images,documents,users,comment,is_favorite',
          'sort': this.sortButton ? 'id' : '-id',
          'page': this.pagination.page,
          'per-page': 5,
        };
        if (this.tab === 0) {
          delete params['search[owner_id]'];
          params['search[user_id]'] = this.filters.workerIds ? [this.user.id, ...this.filters.workerIds] : this.user.id;
        } else {
          params['search[user_id]'] = this.filters.workerIds ? this.filters.workerIds : null;
        }
        if (this.filters.startDoneeDate) params['search[period_notify_at][from_at]'] = this.filters.starDoneDate;
        if (this.filters.endDoneDate) params['search[period_notify_at][to_at]'] = this.filters.endDoneDate;
        const response = await CRUDTasks.getAll(params);
        this.tasks.push(...response.data.data);
        const ownerIds = this.tasks.map(({ owner_id }) => owner_id);
        await this.loadToCache({ key:CACHE_KEYS.users, ids: ownerIds });
        this.pagination = getPagination(response.headers);
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
      setTimeout(null, 500);
      this.loadingNewTasks = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.task-actions {
  visibility: hidden;
}

.task:hover .task-actions {
  visibility: visible;
}
</style>
